import React from "react";

import { useFeatureFlag } from "fond/featureFlags";
import GridBomModal from "fond/project/bom/GridBomModal";
import { BomModalProps } from "fond/project/bom/index";
import TableBomModal from "fond/project/bom/TableBomModal";

const BomModal: React.FC<BomModalProps> = ({ title = "Materials and Costs", project, architecture, onClose }: BomModalProps) => {
  const { value: canAccessGridBom } = useFeatureFlag("grid_bom");
  if (!canAccessGridBom) {
    return <TableBomModal project={project} architecture={architecture} onClose={onClose} title={title} />;
  }

  return <GridBomModal project={project} architecture={architecture} onClose={onClose} title={title} />;
};

export default BomModal;
